import moment from "moment";
import React from "react";
import TimePicker from "../TimePicker.js/TimePicker";
import ActionEditButton from "../UIComponent/ActionTableComponent/ActionEditButton";

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

function AvailabilityScheduleTable(props) {
  return (
    <div className="avaibility-table custom-checkbox-set">
      {
        props.timeSlotList.map((timeSlot, timeSlotIndex) =>
        (
          <table className="w-full bg-white border border-[#757575]" key={`TimeSlotTable_${timeSlotIndex}`}>
            {/* Table header */}
            <thead className=" border border-[#757575] bg-[#f6f6f6]">
              <tr>
                <th className="first:pl-8 last:pr-5 w-[20%] px-2 tbl-th whitespace-nowrap text-[#757575]">
                  <div className="flex items-center tble-th-txt text-left font-normal text-xl">
                    <label className="ml-5">Sessions</label>
                  </div>
                </th>
                <th className="first:pl-8 pr-16 w-[45%] px-2 tbl-th whitespace-nowrap text-[#757575]">
                  <div className="tble-th-txt text-left font-normal text-xl">
                    Schedules
                  </div>
                </th>
                <th className="first:pl-8 last:pr-5 w-[10%] px-2 tbl-th whitespace-nowrap text-[#757575]">
                  <div className=" tble-th-txt text-center font-normal text-xl">
                    Qty
                  </div>
                </th>
                <th className="first:pl-8 last:pr-5 w-[15%] tbl-th px-2 whitespace-nowrap text-[#757575]">
                  <div className="tble-th-txt text-center font-normal text-xl">
                    Seat booked
                  </div>
                </th>
                <th className="first:pl-8 last:pr-5 w-[10%] tbl-th px-2 whitespace-nowrap text-[#757575]">
                  <div className="tble-th-txt text-center font-normal text-xl">
                    <button className="bg-white border border-[#757575] text-[#757575] px-3 hover:border-[#329a03] hover:text-[#329a03]"
                      onClick={() => props.deleteEntryTimeSlotById(timeSlot.eventTimeSlotId)}>
                      Delete
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm custom-tbody">
              {
                timeSlot.lessons.map((lesson, lessonIndex) =>
                (
                  <>
                    {
                      (lesson.eventLessonId === props.editLessonId) ?
                        <tr className="custom-tbl-td-contribution  border-b border-[#c9c9c9] align-baseline" key={`TimeSlotTable${timeSlotIndex}EditIndex_${lessonIndex}`}>
                          <td className="first:pl-8 text-lg py-6 w-[20%]">
                            <div className="flex items-center tble-th-txt text-left font-normal text-xl">
                              <label className="ml-5 text-[#757575]">{`${alphabets.slice(timeSlotIndex, (timeSlotIndex + 1))}${(lessonIndex + 1)}`}</label>
                            </div>
                          </td>
                          <td className="first:pl-8 text-lg py-6 pr-16 w-[45%]">
                            <div className="text-[#757575] text-xl">
                              <div className="grid grid-cols-12 gap-3">
                                <div className="col-span-12 pl-10">
                                  <input
                                    id={`event${timeSlotIndex}LessonDate${lessonIndex}`}
                                    name="eventLessonDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(lesson.eventLessonDate).format("yyyy-MM-DD")}
                                    onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, lessonIndex)}
                                    min={moment(new Date()).format("yyyy-MM-DD")}
                                  />
                                </div>
                                <div className="col-span-12 pl-10">
                                  <div className="grid grid-cols-12 gap-3">
                                    <div className="col-span-6">
                                      <TimePicker
                                        identity={`${timeSlotIndex}/${lessonIndex}/Event/StartTime`}
                                        setTime={props.setTime}
                                        value={lesson.eventStartTime}
                                      />
                                    </div>
                                    <div className="col-span-6">
                                      <TimePicker
                                        identity={`${timeSlotIndex}/${lessonIndex}/Event/EndTime`}
                                        setTime={props.setTime}
                                        value={lesson.eventEndTime}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {(timeSlot.isPhysical || timeSlot.isHybrid) && (props.eventTypeId === 1 || props.eventTypeId === 4||props.eventTypeId === 2 || props.eventTypeId === 3 || props.eventTypeId === 5 || props.eventTypeId === 6 || props.eventTypeId === 9 || props.eventTypeId === 10) ?
                                  <div className="col-span-12">
                                    <div className="grid grid-cols-12 gap-3">
                                      <div className="col-span-12">
                                        <div className="flex items-center mb-2 pl-[3px]">
                                          <label
                                            className="filter-lable block font-medium theme-color min-h-30 pl-3"
                                            htmlFor="default"
                                          >
                                            Address
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="grid grid-cols-12 gap-3">
                                      <div className="col-span-12 pl-10">
                                        <input
                                          id="default"
                                          className="form-input rounded-none w-full shadow-red py-3 text-xl text-[#757575] placeholder-[#757575]"
                                          type="text"
                                          name="address"
                                          value={lesson.address}
                                          onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, lessonIndex)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  null
                                }
                                {
                                  (timeSlot.isOnline || timeSlot.isHybrid) && (props.eventTypeId === 1 || props.eventTypeId === 2 || props.eventTypeId === 3|| props.eventTypeId === 4||props.eventTypeId === 5 ||props.eventTypeId === 6 || props.eventTypeId === 9 || props.eventTypeId === 10) ?
                                    <div className="col-span-12">
                                      <div className="grid grid-cols-12 gap-3">
                                        <div className="col-span-12">
                                          <div className="flex items-center mb-2 pl-[3px]">
                                            {
                                              timeSlot.isMeeting === true ?
                                                <label
                                                  className="filter-lable block font-medium theme-color min-h-30 pl-3"
                                                  htmlFor={`zoomMeetingIdT${timeSlotIndex}S${lessonIndex}`}
                                                >
                                                  Meeting Id
                                                </label>
                                                : null
                                            }
                                            {
                                              timeSlot.isWebinar === true ?
                                                <label
                                                  className="filter-lable block font-medium theme-color min-h-30 pl-3"
                                                  htmlFor={`zoomWebinarIdT${timeSlotIndex}S${lessonIndex}`}
                                                >
                                                  Webinar Id
                                                </label>
                                                : null
                                            }
                                            {
                                              timeSlot.isOthers === true ?
                                                <label
                                                  className="filter-lable block font-medium theme-color min-h-30 pl-3"
                                                  htmlFor={`otherZoomDetailT${timeSlotIndex}S${lessonIndex}`}
                                                >
                                                  Other Details
                                                </label>
                                                : null
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <div className="grid grid-cols-12 gap-3">
                                        <div className={`col-span-12 pl-10 ${props.timeSlotList.bookedSeats > 0 ? "disabled-input" : null}`}>
                                          {
                                            timeSlot.isMeeting === true ?
                                              <input
                                                id={`zoomMeetingIdT${timeSlotIndex}S${lessonIndex}`}
                                                className="form-input rounded-none w-full shadow-red py-3 text-xl text-[#757575] placeholder-[#757575]"
                                                type="text"
                                                name="zoomMeetingId"
                                                onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, lessonIndex)}
                                                value={lesson.zoomMeetingId}
                                                disabled={props.timeSlotList.bookedSeats > 0 ? true : false}
                                              />
                                              : null
                                          }
                                          {
                                            timeSlot.isWebinar === true ?
                                              <input
                                                id={`zoomWebinarIdT${timeSlotIndex}S${lessonIndex}`}
                                                className="form-input rounded-none w-full shadow-red py-3 text-xl text-[#757575] placeholder-[#757575]"
                                                type="text"
                                                name="zoomWebinarId"
                                                onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, lessonIndex)}
                                                value={lesson.zoomWebinarId}
                                                disabled={props.timeSlotList.bookedSeats > 0 ? true : false}
                                              />
                                              : null
                                          }
                                          {
                                            timeSlot.isOthers === true ?
                                              <input
                                                id={`otherZoomDetailT${timeSlotIndex}S${lessonIndex}`}
                                                className="form-input rounded-none w-full shadow-red py-3 text-xl text-[#757575] placeholder-[#757575]"
                                                type="text"
                                                name="otherZoomDetail"
                                                onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, lessonIndex)}
                                                value={lesson.otherZoomDetail}
                                              />
                                              : null
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    :
                                    null
                                }
                              </div>
                            </div>
                          </td>
                          <td className="first:pl-8 text-lg py-6 w-[10%] text-center">
                            {(lessonIndex === 0 ?
                              <div className="text-[#757575] text-xl">
                                <input
                                  id={`availableSeatsT${timeSlotIndex}S${-1}`}
                                  className="form-input rounded-none w-full shadow-red py-3 text-xl text-center text-[#757575] placeholder-[#757575]"
                                  type="text"
                                  name="availableSeats"
                                  value={timeSlot.availableSeats}
                                  onChange={(e) => props.handleChangeInScheduleTable(e, timeSlotIndex, -1)}
                                />
                              </div>

                              :
                              null)}
                          </td>
                          <td className="first:pl-8 text-lg py-6 w-[15%] text-center">
                            {(lessonIndex === 0 ?
                              <div className="text-[#757575] text-xl">0</div>
                              :
                              null)}
                          </td>
                          <td className="first:pl-8 last:pr-5 text-lg py-6 px-2 whitespace-nowrap tble-td-txt w-[10%] text-center">
                            <div className="action-part text-xl text-center">
                              <button className="bg-white border border-[#757575] text-[#757575] px-3 hover:border-[#329a03] hover:text-[#329a03]"
                                onClick={() => props.saveLessonData(timeSlot.eventTimeSlotId, lesson.eventLessonId)}>
                                Save
                              </button>
                            </div>
                          </td>
                        </tr>
                        :
                        <tr className="custom-tbl-td-contribution  border-b border-[#c9c9c9]" key={`TimeSlotTable${timeSlotIndex}Index_${lessonIndex}`}>
                          <td className="first:pl-8 text-lg py-6  w-[20%]">
                            <div className="flex items-center tble-th-txt text-left font-normal text-xl">
                              <label className="ml-5 text-[#757575]">{`${alphabets.slice(timeSlotIndex, (timeSlotIndex + 1))}${(lessonIndex + 1)}`}</label>
                            </div>
                          </td>
                          <td className="first:pl-8 text-lg py-6 pr-16 w-[45%]">
                            <div className="text-[#757575] text-xl">
                              {`${moment(lesson.eventLessonDate).format('dddd, DD MMMM YYYY')}, ${lesson.eventStartTime} - ${lesson.eventEndTime}`}
                              <br />
                              {
                                (timeSlot.isPhysical || timeSlot.isHybrid) && (props.eventTypeId === 1 ||props.eventTypeId === 6 ||props.eventTypeId === 5 ||props.eventTypeId === 3|| props.eventTypeId === 4||props.eventTypeId === 2 || props.eventTypeId === 9 || props.eventTypeId === 10) ?
                                  <p>Address : {lesson.address}</p>
                                  : null
                              }
                              {
                                (timeSlot.isOnline || timeSlot.isHybrid) && (props.eventTypeId === 1 || props.eventTypeId === 4||props.eventTypeId === 2 || props.eventTypeId === 9 || props.eventTypeId === 10) ?
                                  <>
                                    {(timeSlot.isMeeting) ?
                                      <p>Zoom Meeting Id: {lesson.zoomMeetingId}</p>
                                      : null
                                    }
                                    {(timeSlot.isWebinar) ?
                                      <p>Zoom Webinar Id: {lesson.zoomWebinarId}</p>
                                      : null
                                    }
                                    {(timeSlot.isOthers) ?
                                      <p>Zoom Other Detail: {lesson.otherZoomDetail}</p>
                                      : null
                                    }
                                  </>
                                  : null
                              }
                            </div>
                          </td>
                          <td className="first:pl-8 text-lg py-6  w-[10%]">
                            {
                              (lessonIndex === 0) ?
                                <div className="text-[#757575] text-xl text-center">{timeSlot.availableSeats}</div>
                                :
                                null
                            }
                          </td>
                          <td className="first:pl-8 text-lg py-6  w-[15%] text-center">
                            {
                              (lessonIndex === 0) ?
                                <div className="text-[#757575] text-xl">{timeSlot.bookedSeats}</div>
                                :
                                null
                            }
                          </td>
                          <td className="first:pl-8 last:pr-5 text-lg py-6 px-2 whitespace-nowrap tble-td-txt  w-[10%] text-center">
                            <div className="action-part text-xl text-center">
                              <ActionEditButton
                                text="Edit"
                                onActionClick={(value, index, e) => props.editLessonData(timeSlot.eventTimeSlotId, lesson.eventLessonId, e)}
                              />
                            </div>
                          </td>
                        </tr>
                    }
                  </>
                ))
              }
            </tbody>
          </table>
        )
        )
      }
    </div>
  );
}

export default AvailabilityScheduleTable;
